import GalleryTemplate from 'components/templates/GalleryTemplate';
import React from 'react';

const Gallery: React.FC = () => {
    return <GalleryTemplate />;
};

export default Gallery;
